import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";import _createClass from "@babel/runtime-corejs3/helpers/createClass";import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";import _inherits from "@babel/runtime-corejs3/helpers/inherits";import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = _getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = _getPrototypeOf(this).constructor;result = _Reflect$construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return _possibleConstructorReturn(this, result);};}function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !_Reflect$construct) return false;if (_Reflect$construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}import { autorun, makeObservable } from 'mobx';

import { BasicFormController } from "./BasicFormController";






export var FormController = /*#__PURE__*/function (_BasicFormController) {_inherits(FormController, _BasicFormController);var _super = _createSuper(FormController);


  function FormController(fields) {var _this;_classCallCheck(this, FormController);
    _this = _super.call(this, fields);

    // Reaction that iterates over all the form controls in the 'fields' and filter out the ones that
    // have dependencyFields property. If any of the form fields listed in the dependencyFields
    // property has any value that is different form the initialValue of that field, than the
    // 'optional' flag of the FormControl under check is set to 'false', otherwise - set to 'true'.
    autorun(function () {
      _Object$keys(_this.fields).forEach(function (key) {
        var currentControl = _this.fields[key];
        if (currentControl.dependencyFields.length > 0) {var _context;
          var dependingFieldsHaveValues = _mapInstanceProperty(_context = currentControl.dependencyFields).call(_context, function (fieldName) {
            var controlUnderCheck = _this.fields[fieldName];
            if (!controlUnderCheck) {
              throw new Error("There is no control named ".concat(fieldName, " in the form!"));
            }
            return controlUnderCheck.value !== controlUnderCheck.initialValue;
          });
          if (dependingFieldsHaveValues.some(function (value) {return value;})) {
            currentControl.setOptionalFlag(false);
          } else {
            currentControl.setOptionalFlag(true);
          }
        }
      });
    });

    makeObservable(_assertThisInitialized(_this), {});return _this;
  }return _createClass(FormController);}(BasicFormController);
//# sourceMappingURL=FormController.js.map